import { render, staticRenderFns } from "./laxin.vue?vue&type=template&id=7e50eaf0&scoped=true&"
import script from "./laxin.vue?vue&type=script&lang=js&"
export * from "./laxin.vue?vue&type=script&lang=js&"
import style0 from "./laxin.vue?vue&type=style&index=0&id=7e50eaf0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e50eaf0",
  null
  
)

export default component.exports